import { FaBarcode, FaFileAlt, FaFilm, FaMicrophone, FaQrcode, FaTshirt, FaWallet } from "react-icons/fa";
import { FiGlobe, FiShield, FiSmartphone } from "react-icons/fi";
import { TbSparkles } from "react-icons/tb";

const projectMarks = {
  film: FaFilm,
  mic: FaMicrophone,
  globe: FiGlobe,
  shield: FiShield,
  phone: FiSmartphone,
  qr: FaQrcode,
  barcode: FaBarcode,
  wallet: FaWallet,
  resume: FaFileAlt,
  ai: TbSparkles,
  wardrobe: FaTshirt,
};

export default projectMarks;
